import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useMedia } from "./useMedia";
import { useConsentService } from "@aviv-csnt/react";
import { MediaOverlay } from "./MediaOverlay";
import { useI18n } from "@/shared/hooks";
export const ConsentLayer = ({ media }) => {
    const { showBanner } = useConsentService();
    const { previewUrl, previewFallBackUrl } = useMedia(media);
    const consentLayerBackground = previewUrl !== null && previewUrl !== void 0 ? previewUrl : previewFallBackUrl;
    const { t } = useI18n();
    return (_jsxs(Box, { position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "radius.16", overflow: "hidden", maxHeight: "100%", unsafe_style: {
            width: "100%",
            aspectRatio: "4/3",
        }, onClick: showBanner, cursor: "pointer", children: [_jsx(Box, { position: "absolute", backgroundImage: `url(${consentLayerBackground})`, backgroundSize: "cover", backgroundPosition: "center", transform: "scale(1.1)", unsafe_style: {
                    filter: "blur(12px) brightness(0.6)",
                    inset: "0",
                } }), _jsx(MediaOverlay, { media: media, onClick: showBanner }), _jsxs(Box, { position: "absolute", zIndex: "zIndex.2", color: "color.background.constant.white", padding: "spacing.16", marginTop: "spacing.128", textAlign: "center", typography: {
                    "breakpoint.base": "typography.body.11.bold",
                    "breakpoint.md": "typography.body.14.bold",
                }, onClick: showBanner, children: [t("consent.consent_layer.label"), _jsx("br", {}), t("consent.consent_layer.label_click")] })] }));
};
